ixModuleRouting("impactx.retoure", {
    "/retourelist": {
        template: "<ixa-retoure-list></ixa-retoure-list>",
        templateUrl: "modules/retoure/templates/retourelist.html",
        process: "Retoure",
        controller: "RetoureListCtrl",
        controllerAs: "retoureListCtrl",
        workspace: "shop",
    },
    "/retoure/:id": {
        template: "<ixa-retoure-detail></ixa-retoure-detail>",
        templateUrl: "modules/retoure/templates/retoure.html",
        process: "ViewRetoure",
        controller: "RetoureDetailCtrl",
        controllerAs: "retoureDetailCtrl",
        workspace: "shop",
    },
});
